import React from "react";

const styles = {
  colorful: {
    width: "44.8px",
    height: "44.8px",
    borderRadius: "50%",
    background:
      "linear-gradient(#3bff81 0 0), linear-gradient(#3bff81 0 0), linear-gradient(#fdfcf8 0 0), linear-gradient(#fdfcf8 0 0), linear-gradient(#6fff61 0 0), linear-gradient(#6fff61 0 0), linear-gradient(#f2f7f3 0 0), linear-gradient(#f2f7f3 0 0), #3bff81",
    backgroundPosition: "top left, bottom right",
    backgroundRepeat: "no-repeat",
    animation: "colorful-f5f9ie 2.5s infinite",
  },
};

export default function Loader() {
  return (
    <>
      <style>
        {`
          @keyframes colorful-f5f9ie {
            0% {
              background-size: 0 100%, 0 100%, 100% 0, 100% 0, 0 100%, 0 100%, 100% 0, 100% 0;
            }
            20%, 25% {
              background-size: 0 100%, 0 100%, 100% 0, 100% 0, 0 100%, 0 100%, 100% 50%, 100% 50%;
            }
            45%, 50% {
              background-size: 0 100%, 0 100%, 100% 0, 100% 0, 50% 100%, 50% 100%, 100% 50%, 100% 50%;
            }
            70%, 75% {
              background-size: 0 100%, 0 100%, 100% 50%, 100% 50%, 50% 100%, 50% 100%, 100% 50%, 100% 50%;
            }
            95%, 100% {
              background-size: 50% 100%, 50% 100%, 100% 50%, 100% 50%, 50% 100%, 50% 100%, 100% 50%, 100% 50%;
            }
          }
        `}
      </style>
      <div className="flex w-screen bg-black h-screen justify-center items-center">
        <div>
          <div style={styles.colorful}></div>
          <p className="text-white text-2xl text-center -translate-x-4 mt-3">loading...</p>
        </div>
      </div>
    </>
  );
}
